export const formatPrice = (value: number | string, symbol: string) => {
  if (!value) return `0${symbol}`
  return `${value}${symbol}`
}

export const diffInPercent = (from: number, value: number, precision = 0) =>
  Math.abs(100 - (100 / from) * value).toFixed(precision)
